<template>
	<div id="app">
		<div class="header">
			<div class="contenedor-header">
				<div class="container d-flex align-items-center justify-content-center">
					<a href="https://www.biobiochile.cl" class="logo-bbcl"><img src="./assets/img/logo_bbcl.png" /></a>
					<div class="menu ml-auto d-none d-md-block">
						<a href="https://www.biobiochile.cl/especial/una-constitucion-para-chile/">NOTICIAS</a>
					</div>
					<div class="menu ml-3 d-none d-md-block">
						<a href="https://www.biobiochile.cl/resultados-elecciones-constituyentes/gobernadores.shtml">SEGUNDA VUELTA GOBERNADORES</a>
					</div>
					<div class="redes d-none d-md-block">
						<a href="https://www.facebook.com/RadioBioBio"><i class="fab fa-facebook-f"></i></a>
						<a href="https://twitter.com/biobio"><i class="fab fa-twitter"></i></a>
						<a href="https://www.instagram.com/biobiochile/"><i class="fab fa-instagram"></i></a>
						<a href="https://www.youtube.com/channel/UCuvM3c8rmdApmk-g22shZ7w"><i class="fab fa-youtube"></i></a>
					</div>
				</div>
			</div>
			<div class="titulo">
				<div class="estrellas"><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i></div>
				<h1>Resultados Elecciones 2021</h1>
			</div>
		</div>
		<elecciones></elecciones>
		<div class="footer">
			<img src="./assets/img/logo_bbcl_footer.png" />
			<p>Desarrollado por Bío Bío Comunicaciones Concepción - Chile</p>
		</div>
	</div>
</template>

<script>
import Elecciones from './components/Elecciones'

export default {
	name: 'App',
	components: {
		Elecciones
	}
}
</script>

<style lang="scss" scoped>
.header {
	background-image: url(./assets/img/bg_movil.png);
	background-position: center top;
	background-size: cover;
	background-repeat: no-repeat;
	padding-bottom: 27px;

	.contenedor-header {
		border-bottom: 1px solid rgba(136, 153, 166, 0.3);
		padding: 16px;

		.logo-bbcl img {
			width: auto;
			height: 29px;
		}
	}

	.titulo {
		text-align: center;
		margin-top: 47px;

		h1 {
			color: #ffffff;
			font-family: 'Martel', serif;
			font-size: 22px;
			font-weight: bold;
			letter-spacing: 0;
			line-height: 25px;
		}

		.estrellas {
			opacity: 0.4;
			color: #ffffff;
			font-size: 9px;
			margin-bottom: 10px;
			i:nth-child(2) {
				font-size: 12px;
				margin: 0 16px;
			}
		}
	}
}

.footer {
	height: 165px;
	background-color: #d4dae3;
	text-align: center;
	padding-top: 50px;
	padding-bottom: 30px;

	img {
		height: 24px;
		width: auto;
		margin-bottom: 50px;
	}

	p {
		color: #8899a6;
		font-family: Lato;
		font-size: 13px;
		letter-spacing: 0;
		line-height: 12px;
	}
}

@media (min-width: 768px) {
	.header {
		background-image: url(./assets/img/bg_escritorio.png);
		padding-bottom: 68px;

		.contenedor-header {
			border-bottom: 1px solid rgba(136, 153, 166, 0.3);
			padding: 16px;

			.logo-bbcl img {
				width: auto;
				height: 26px;
			}
			.menu a {
				font-family: Lato;
				font-size: 13px;
				letter-spacing: 0;
				line-height: 18px;
				margin-right: 50px;
			}
			.redes a {
				font-size: 16px;
				letter-spacing: 0;
				margin-left: 30px;
			}
		}
	}
}
</style>
